(function () {
  if (window.__tk9CartUpsellShadowLoaded) return;
  window.__tk9CartUpsellShadowLoaded = true;

  var DEFAULT_CONFIG = {
    enabled: true,
    rulesUrl: "",
    maxVisibleOffers: 3,
    cartUrl: "/cart.js",
    debug: false,
    evaluateDelayMs: 250,
    storageKey: "tk9_cart_upsell_shadow_last_signature"
  };

  var config = Object.assign({}, DEFAULT_CONFIG, window.TeamK9CartUpsellShadowConfig || {});
  var state = {
    rules: null,
    cart: null,
    result: null,
    loadingRules: null,
    evaluationTimer: null
  };

  function isDebugEnabled() {
    try {
      return Boolean(
        config.debug ||
          /(?:\?|&)tk9_cart_shadow_debug=1(?:&|$)/.test(window.location.search) ||
          window.localStorage.getItem("tk9_cart_shadow_debug") === "1"
      );
    } catch (error) {
      return Boolean(config.debug);
    }
  }

  function debugLog() {
    if (!isDebugEnabled()) return;
    try {
      var args = Array.prototype.slice.call(arguments);
      args.unshift("[Team K9 cart shadow]");
      console.info.apply(console, args);
    } catch (error) {}
  }

  function toNumber(value) {
    var number = Number(value);
    return Number.isFinite(number) ? number : 0;
  }

  function uniqueNumbers(values) {
    var seen = {};
    return (values || [])
      .map(toNumber)
      .filter(function (value) {
        if (!value || seen[value]) return false;
        seen[value] = true;
        return true;
      });
  }

  function cartItems(cart) {
    return Array.isArray(cart && cart.items) ? cart.items : [];
  }

  function cartProductIds(cart) {
    return uniqueNumbers(
      cartItems(cart).map(function (item) {
        return item.product_id || item.productId;
      })
    );
  }

  function cartVariantIds(cart) {
    return uniqueNumbers(
      cartItems(cart).map(function (item) {
        return item.variant_id || item.variantId || item.id;
      })
    );
  }

  function cartContainsProductId(cart, productId) {
    var target = toNumber(productId);
    return cartProductIds(cart).indexOf(target) !== -1;
  }

  function cartContainsVariantId(cart, variantId) {
    var target = toNumber(variantId);
    return cartVariantIds(cart).indexOf(target) !== -1;
  }

  function conditionPasses(condition, cart) {
    if (!condition || typeof condition !== "object") return true;
    if (condition.cartContainsProductId) return cartContainsProductId(cart, condition.cartContainsProductId);
    if (condition.cartDoesNotContainProductId) return !cartContainsProductId(cart, condition.cartDoesNotContainProductId);
    if (condition.cartContainsVariantId) return cartContainsVariantId(cart, condition.cartContainsVariantId);
    if (condition.cartDoesNotContainVariantId) return !cartContainsVariantId(cart, condition.cartDoesNotContainVariantId);
    if (condition.cartSubtotalAtLeastCents !== undefined) return toNumber(cart.total_price) >= toNumber(condition.cartSubtotalAtLeastCents);
    if (condition.cartSubtotalBelowCents !== undefined) return toNumber(cart.total_price) < toNumber(condition.cartSubtotalBelowCents);
    if (condition.cartItemCountAtLeast !== undefined) return toNumber(cart.item_count) >= toNumber(condition.cartItemCountAtLeast);
    if (condition.cartItemCountBelow !== undefined) return toNumber(cart.item_count) < toNumber(condition.cartItemCountBelow);
    return true;
  }

  function triggerPasses(trigger, cart) {
    var all = Array.isArray(trigger && trigger.all) ? trigger.all : [];
    var any = Array.isArray(trigger && trigger.any) ? trigger.any : [];
    var none = Array.isArray(trigger && trigger.none) ? trigger.none : [];

    if (all.some(function (condition) { return !conditionPasses(condition, cart); })) return false;
    if (any.length && !any.some(function (condition) { return conditionPasses(condition, cart); })) return false;
    if (none.some(function (condition) { return conditionPasses(condition, cart); })) return false;

    var suppressed = uniqueNumbers(trigger && trigger.suppressIfCartContainsAnyProductIds);
    if (suppressed.some(function (productId) { return cartContainsProductId(cart, productId); })) return false;

    return true;
  }

  function normalizeOffer(offer) {
    return {
      productId: toNumber(offer.productId),
      handle: offer.handle || "",
      rank: toNumber(offer.rank) || 999,
      reason: offer.reason || "",
      lineItemProperties: Array.isArray(offer.lineItemProperties) ? offer.lineItemProperties : []
    };
  }

  function evaluateOfferGroup(group, cart, rules) {
    if (!triggerPasses(group.trigger, cart)) return null;

    var visibleOffers = (group.offers || [])
      .map(normalizeOffer)
      .filter(function (offer) {
        return offer.productId && !cartContainsProductId(cart, offer.productId);
      })
      .sort(function (a, b) {
        return a.rank - b.rank;
      })
      .slice(0, toNumber(rules.cart && rules.cart.maxVisibleOffers) || config.maxVisibleOffers);

    if (!visibleOffers.length) return null;

    return {
      id: group.id,
      title: group.title || "",
      priority: toNumber(group.priority),
      moment: group.moment || "cart",
      sourceApp: group.sourceApp || "native",
      sourceOfferId: group.sourceOfferId || null,
      offers: visibleOffers
    };
  }

  function evaluateDynamicOffer(dynamicOffer, cart) {
    if (!triggerPasses(dynamicOffer.trigger, cart)) return null;
    var candidates = uniqueNumbers(dynamicOffer.candidateProductIds).filter(function (productId) {
      return !cartContainsProductId(cart, productId);
    });
    if (!candidates.length) return null;
    return {
      id: dynamicOffer.id,
      title: dynamicOffer.title || "",
      priority: toNumber(dynamicOffer.priority),
      moment: dynamicOffer.moment || "cart",
      strategy: dynamicOffer.strategy || "",
      candidateProductIds: candidates
    };
  }

  function evaluateCart(cart, rules) {
    var offerGroups = (rules.offerGroups || [])
      .map(function (group) {
        return evaluateOfferGroup(group, cart, rules);
      })
      .filter(Boolean)
      .sort(function (a, b) {
        return b.priority - a.priority;
      });

    var dynamicOffers = (rules.dynamicOffers || [])
      .map(function (offer) {
        return evaluateDynamicOffer(offer, cart);
      })
      .filter(Boolean)
      .sort(function (a, b) {
        return b.priority - a.priority;
      });

    var primaryGroup = offerGroups[0] || null;

    return {
      version: rules.version || "",
      evaluatedAt: new Date().toISOString(),
      cart: {
        itemCount: toNumber(cart.item_count),
        totalPrice: toNumber(cart.total_price),
        productIds: cartProductIds(cart),
        variantIds: cartVariantIds(cart)
      },
      primaryGroup: primaryGroup,
      eligibleGroups: offerGroups,
      dynamicOffers: dynamicOffers
    };
  }

  function signatureFor(result) {
    return JSON.stringify({
      totalPrice: result.cart.totalPrice,
      itemCount: result.cart.itemCount,
      productIds: result.cart.productIds,
      primaryGroup: result.primaryGroup && result.primaryGroup.id,
      primaryOffers: result.primaryGroup ? result.primaryGroup.offers.map(function (offer) { return offer.productId; }) : [],
      dynamicOffers: result.dynamicOffers.map(function (offer) { return offer.id; })
    });
  }

  function emitDataLayer(eventName, payload) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: eventName }, payload || {}));
  }

  function emitResult(result) {
    var signature = signatureFor(result);
    var previousSignature = "";

    try {
      previousSignature = window.sessionStorage.getItem(config.storageKey) || "";
      window.sessionStorage.setItem(config.storageKey, signature);
    } catch (error) {}

    state.result = result;
    window.TeamK9CartUpsellShadow.lastResult = result;

    document.dispatchEvent(
      new CustomEvent("tk9:cart-upsell-shadow:evaluated", {
        detail: result
      })
    );

    if (signature === previousSignature) {
      debugLog("unchanged", result);
      return;
    }

    emitDataLayer("tk9_upsell_shadow_evaluated", {
      tk9_cart_total_price: result.cart.totalPrice,
      tk9_cart_item_count: result.cart.itemCount,
      tk9_primary_group_id: result.primaryGroup ? result.primaryGroup.id : "",
      tk9_primary_offer_product_ids: result.primaryGroup
        ? result.primaryGroup.offers.map(function (offer) { return offer.productId; }).join(",")
        : "",
      tk9_dynamic_offer_ids: result.dynamicOffers.map(function (offer) { return offer.id; }).join(",")
    });

    result.eligibleGroups.forEach(function (group) {
      emitDataLayer("tk9_upsell_group_eligible", {
        tk9_upsell_group_id: group.id,
        tk9_upsell_group_priority: group.priority,
        tk9_upsell_offer_product_ids: group.offers.map(function (offer) { return offer.productId; }).join(",")
      });
    });

    debugLog("evaluated", result);
  }

  function loadRules() {
    if (state.rules) return Promise.resolve(state.rules);
    if (state.loadingRules) return state.loadingRules;
    if (!config.rulesUrl) return Promise.reject(new Error("Missing Team K9 upsell rules URL"));

    state.loadingRules = fetch(config.rulesUrl, {
      credentials: "same-origin",
      cache: "no-store"
    })
      .then(function (response) {
        if (!response.ok) throw new Error("Unable to load Team K9 upsell rules");
        return response.json();
      })
      .then(function (rules) {
        state.rules = rules;
        return rules;
      })
      .catch(function (error) {
        state.loadingRules = null;
        throw error;
      });

    return state.loadingRules;
  }

  function fetchCart() {
    return fetch(config.cartUrl, {
      credentials: "same-origin",
      cache: "no-store"
    }).then(function (response) {
      if (!response.ok) throw new Error("Unable to load cart");
      return response.json();
    });
  }

  function evaluateNow(source) {
    if (!config.enabled) return Promise.resolve(null);
    return Promise.all([loadRules(), fetchCart()])
      .then(function (results) {
        var rules = results[0];
        var cart = results[1];
        state.cart = cart;
        var result = evaluateCart(cart, rules);
        result.source = source || "manual";
        emitResult(result);
        return result;
      })
      .catch(function (error) {
        debugLog("evaluation failed", error);
        return null;
      });
  }

  function scheduleEvaluation(source) {
    window.clearTimeout(state.evaluationTimer);
    state.evaluationTimer = window.setTimeout(function () {
      evaluateNow(source);
    }, toNumber(config.evaluateDelayMs));
  }

  function watchFetchCartMutations() {
    if (window.__tk9CartUpsellShadowFetchWatched || typeof window.fetch !== "function") return;
    window.__tk9CartUpsellShadowFetchWatched = true;

    var originalFetch = window.fetch;
    window.fetch = function () {
      var args = arguments;
      var request = args[0];
      var url = typeof request === "string" ? request : request && request.url;
      var isCartMutation = /\/cart\/(?:add|change|update|clear)\.js(?:\?|$)|\/cart\/(?:add|change|update|clear)(?:\?|$)/.test(String(url || ""));

      return originalFetch.apply(this, args).then(function (response) {
        if (isCartMutation) {
          window.setTimeout(function () {
            scheduleEvaluation("fetch-cart-mutation");
          }, 50);
        }
        return response;
      });
    };
  }

  window.TeamK9CartUpsellShadow = {
    evaluate: function () {
      return evaluateNow("api");
    },
    evaluateCart: evaluateCart,
    getState: function () {
      return {
        rules: state.rules,
        cart: state.cart,
        result: state.result
      };
    },
    schedule: scheduleEvaluation
  };

  if (!config.enabled) {
    debugLog("disabled");
    return;
  }

  watchFetchCartMutations();

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      scheduleEvaluation("dom-ready");
    }, { once: true });
  } else {
    scheduleEvaluation("initial");
  }

  window.addEventListener("pageshow", function () {
    scheduleEvaluation("pageshow");
  });

  document.addEventListener("cart:updated", function () {
    scheduleEvaluation("cart-updated-event");
  });

  document.addEventListener("cart:refresh", function () {
    scheduleEvaluation("cart-refresh-event");
  });
})();
